import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BreadcrumbsComponent } from './breadcrumbs.component';
export class BreadcrumbsModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, RouterModule],
  exports: [BreadcrumbsComponent],
  declarations: [BreadcrumbsComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function BreadcrumbsModule_tsickle_Closure_declarations() {
/** @type {?} */
BreadcrumbsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BreadcrumbsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
